import { render, staticRenderFns } from "./contenido.vue?vue&type=template&id=826c4898&scoped=true&"
import script from "./contenido.vue?vue&type=script&lang=js&"
export * from "./contenido.vue?vue&type=script&lang=js&"
import style0 from "./contenido.vue?vue&type=style&index=0&id=826c4898&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826c4898",
  null
  
)

export default component.exports